import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=da69e3b4&scoped=true&v-if=hasTeam&"
import script from "./Items.vue?vue&type=script&lang=js&"
export * from "./Items.vue?vue&type=script&lang=js&"
import style0 from "./Items.vue?vue&type=style&index=0&id=da69e3b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da69e3b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da69e3b4')) {
      api.createRecord('da69e3b4', component.options)
    } else {
      api.reload('da69e3b4', component.options)
    }
    module.hot.accept("./Items.vue?vue&type=template&id=da69e3b4&scoped=true&v-if=hasTeam&", function () {
      api.rerender('da69e3b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/Items/Items.vue"
export default component.exports